import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { FuncService } from 'src/app/services/functions-api.service';

@Component({
    selector: 'app-unauthorized',
    templateUrl: './unauthorized.component.html',
    styleUrls: ['./unauthorized.component.scss'],
})
export class UnauthorizedComponent implements OnInit {
    constructor(
        public func: FuncService,
        public auth: AuthService
    ) {}

    ngOnInit(): void {
        console.log('20220825_1545');
    }
}
